<template>
  <div>
    <div ref="controlShow" v-if="isShowBig==true" class="main-detail">
      <div class="main-bg">
        <div class="close" @click="closeBtn()"><img src="../../../assets/images/springFrame/loginOut.png"></div>
        <div>
          <manuscript-content :showManuObj="showObj"></manuscript-content>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
  import ManuscriptContent from '@/views/index/pubFolder/manuscriptContent.vue';

  export default {
    name: 'pubDetail',
    props: {
      // 是否展示大弹窗
      isShowBig: {
        type: Boolean,
        default: false
      },
      showObj: {
        type: Object,
        default: {}
      },
    },
    data(){
      return {
        isShowBigTemp: this.isShowBig,
      }
    },
    components: { ManuscriptContent },
    mounted(){

    },
    methods: {
      closeBtn(){
        this.isShowBigTemp = false;
        this.$emit('showManuJZ', this.isShowBigTemp);
      },
    },
  }
</script>

<style>
  .main-detail {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.5);
    z-index: 9;
  }
  .main-detail .main-bg {
    width: 2000px;
    height: 1300px;
    background: url('../../../assets/images/springFrame/bottom.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

  }
  .main .main-bg .close {
    cursor: pointer;
  }
  .main .main-bg .close img {
    width:55px;
    height:55px;
    float:right;
    margin-right: 90px;
    margin-top: 30px;
  }
  
</style>